import React, { useContext, useState } from "react";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import StarekContext from "../context/StarekContext";
import { usePermissions } from "../hooks/usePermissions";

function Menu() {
    const starekContext = useContext(StarekContext);
    const navigator = useNavigate();
    const { can } = usePermissions();

    const [openMenus, setOpenMenus] = useState({
        setup: false,
        plan: false,
        track: false,
        manage: false,
    });

    const toggleMenu = (key) => {
        setOpenMenus((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleSwitchPlant = () => {
        sessionStorage.setItem(
            "postAuthRedirect",
            window.location.pathname + window.location.search,
        );
        navigator("/choose-plant");
    };

    //Show section if one menu is visiblee.....
    const showParts = can("part", "READ");
    const showOperations = can("operation", "READ");
    const showShifts = can("shift", "READ");
    const showZones = can("zone", "READ");
    const showSetup = showParts || showOperations || showShifts || showZones;

    const showJobSched = can("job_schedule", "READ");
    const showPlan = showJobSched;

    const showReports = can("report", "READ");
    const showTrack = showReports;

    const showDevProf = can("device_profile", "READ");
    const showDevices = can("device", "READ");
    const showSettings = can("setting", "READ");
    const showUsers = can("user", "READ");
    const showRoles = can("role", "READ");
    const showManage =
        showDevProf || showDevices || showSettings || showUsers || showRoles;

    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
            {/*Starek Logo */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0 1.5rem",
                    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                    height: "73px",
                }}
            >
                <a href="/" className="text-decoration-none">
                    <img
                        src="/dist/img/light-starek-brand-512x512.png"
                        alt="Starek"
                        style={{
                            height: "50px",
                            width: "auto",
                            maxWidth: "140px",
                            objectFit: "contain",
                        }}
                    />
                </a>
            </div>

            {/* Plant Name Section*/}
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "0.75rem 1rem",
                    gap: "0.5rem",
                }}
            >
                <span
                    onClick={handleSwitchPlant}
                    role="button"
                    style={{
                        fontSize: "0.9rem",
                        color: "#fff",
                        fontWeight: "600",
                        cursor: "pointer",
                        textDecoration: "underline",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#a8d5ff";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#fff";
                    }}
                >
                    {starekContext?.lastUsedPlant?.name || "No Plant"}
                </span>
            </div>

            <div
                className="sidebar"
                style={{
                    overflowY: "auto",
                    overflowX: "hidden",
                    height: "calc(100vh - 145px)",
                    scrollbarWidth: "thin",
                    scrollbarColor: "#888 #f1f1f1",
                }}
            >
                <nav className="mt-2">
                    <ul
                        className="nav nav-pills nav-sidebar flex-column"
                        role="menu"
                    >
                        <hr className="text-white mt-2 mx-n2" />

                        <li className="nav-item">
                            <NavLink className="nav-link" to="/">
                                <i className="nav-icon fas fa-th tw-text-[#c2c7d0]" />
                                <p>
                                    <b className="tw-text-[#c2c7d0]">
                                        DASHBOARD
                                    </b>
                                </p>
                            </NavLink>
                        </li>

                        {showSetup && (
                            <li
                                className={`nav-item ${openMenus.setup ? "menu-open" : ""}`}
                            >
                                <div
                                    onClick={() => toggleMenu("setup")}
                                    className="nav-link"
                                >
                                    <i className="nav-icon fa fa-clone tw-text-[#c2c7d0]" />
                                    <p>
                                        <b className="tw-text-[#c2c7d0]">
                                            SETUP
                                        </b>
                                        <i className="right fas fa-angle-left tw-text-[#c2c7d0]" />
                                    </p>
                                </div>
                                <ul
                                    className="nav nav-treeview"
                                    style={{
                                        display: openMenus.setup
                                            ? "block"
                                            : "none",
                                    }}
                                >
                                    {showParts && (
                                        <li className="nav-item">
                                            <NavLink
                                                className="nav-link"
                                                to="/parts"
                                            >
                                                <i className="fa fa-cube nav-icon" />
                                                <p>Parts</p>
                                            </NavLink>
                                        </li>
                                    )}
                                    {showOperations && (
                                        <li className="nav-item">
                                            <NavLink
                                                className="nav-link"
                                                to="/operations"
                                            >
                                                <i className="fa fa-tasks nav-icon" />
                                                <p>Operations</p>
                                            </NavLink>
                                        </li>
                                    )}
                                    {showShifts && (
                                        <li className="nav-item">
                                            <NavLink
                                                className="nav-link"
                                                to="/shifts"
                                            >
                                                <i className="fa fa-clipboard nav-icon" />
                                                <p>Shifts</p>
                                            </NavLink>
                                        </li>
                                    )}
                                    {showZones && (
                                        <li className="nav-item">
                                            <NavLink
                                                className="nav-link"
                                                to="/zones"
                                            >
                                                <i className="fa fa-bullseye nav-icon" />
                                                <p>Zones</p>
                                            </NavLink>
                                        </li>
                                    )}
                                </ul>
                            </li>
                        )}

                        {showPlan && (
                            <li
                                className={`nav-item ${openMenus.plan ? "menu-open" : ""}`}
                            >
                                <div
                                    onClick={() => toggleMenu("plan")}
                                    className="nav-link"
                                >
                                    <i className="nav-icon fa fa-drafting-compass tw-text-[#c2c7d0]" />
                                    <p>
                                        <b className="tw-text-[#c2c7d0]">
                                            PLAN
                                        </b>
                                        <i className="right fas fa-angle-left tw-text-[#c2c7d0]" />
                                    </p>
                                </div>
                                <ul
                                    className="nav nav-treeview"
                                    style={{
                                        display: openMenus.plan
                                            ? "block"
                                            : "none",
                                    }}
                                >
                                    {showJobSched && (
                                        <li className="nav-item">
                                            <NavLink
                                                className="nav-link"
                                                to="/job-schedules"
                                            >
                                                <i className="far fa-calendar nav-icon" />
                                                <p>Job Schedules</p>
                                            </NavLink>
                                        </li>
                                    )}
                                    {showJobSched && (
                                        <li className="nav-item">
                                            <NavLink
                                                className="nav-link"
                                                to="/maintenance"
                                            >
                                                <i className="fa fa-cogs nav-icon" />
                                                <p>Maintenance</p>
                                            </NavLink>
                                        </li>
                                    )}
                                </ul>
                            </li>
                        )}

                        {showTrack && (
                            <li
                                className={`nav-item ${openMenus.track ? "menu-open" : ""}`}
                            >
                                <div
                                    onClick={() => toggleMenu("track")}
                                    className="nav-link"
                                >
                                    <i className="nav-icon fas fa-chart-line tw-text-[#c2c7d0]" />
                                    <p>
                                        <b className="tw-text-[#c2c7d0]">
                                            TRACK
                                        </b>
                                        <i className="fas fa-angle-left right tw-text-[#c2c7d0]" />
                                    </p>
                                </div>
                                <ul
                                    className="nav nav-treeview"
                                    style={{
                                        display: openMenus.track
                                            ? "block"
                                            : "none",
                                    }}
                                >
                                    {showReports && (
                                        <li className="nav-item">
                                            <NavLink
                                                className="nav-link"
                                                to="/reports"
                                            >
                                                <i className="fa fa-file-alt nav-icon" />
                                                <p>Reports</p>
                                            </NavLink>
                                        </li>
                                    )}
                                    {showReports && (
                                        <li className="nav-item">
                                            <NavLink
                                                className="nav-link"
                                                to="/reports-v2"
                                            >
                                                <i className="fa fa-chart-line nav-icon" />
                                                <p>Reports (Phase 1)</p>
                                            </NavLink>
                                        </li>
                                    )}
                                    {showReports && (
                                        <li className="nav-item">
                                            <NavLink
                                                className="nav-link"
                                                to="/fav-reports"
                                            >
                                                <i className="fa fa-star nav-icon" />
                                                <p>Favourite Reports</p>
                                            </NavLink>
                                        </li>
                                    )}
                                </ul>
                            </li>
                        )}

                        {showManage && (
                            <li
                                className={`nav-item ${openMenus.manage ? "menu-open" : ""}`}
                            >
                                <div
                                    onClick={() => toggleMenu("manage")}
                                    className="nav-link"
                                >
                                    <i className="nav-icon fa fa-cog tw-text-[#c2c7d0]" />
                                    <p>
                                        <b className="tw-text-[#c2c7d0]">
                                            MANAGE
                                        </b>
                                        <i className="fas fa-angle-left right tw-text-[#c2c7d0]" />
                                    </p>
                                </div>
                                <ul
                                    className="nav nav-treeview"
                                    style={{
                                        display: openMenus.manage
                                            ? "block"
                                            : "none",
                                    }}
                                >
                                    {showDevProf && (
                                        <li className="nav-item">
                                            <NavLink
                                                className="nav-link"
                                                to="/device-profiles"
                                            >
                                                <i className="fa fa-sd-card nav-icon" />
                                                <p>Device Profiles</p>
                                            </NavLink>
                                        </li>
                                    )}
                                    {showDevices && (
                                        <li className="nav-item">
                                            <NavLink
                                                className="nav-link"
                                                to="/devices"
                                            >
                                                <i className="fa fa-microchip nav-icon" />
                                                <p>Devices</p>
                                            </NavLink>
                                        </li>
                                    )}
                                    {showUsers && (
                                        <li className="nav-item">
                                            <NavLink
                                                className="nav-link"
                                                to="/users"
                                            >
                                                <i className="fa fa-user nav-icon" />
                                                <p>Users</p>
                                            </NavLink>
                                        </li>
                                    )}
                                    {showRoles && (
                                        <li className="nav-item">
                                            <NavLink
                                                className="nav-link"
                                                to="/roles"
                                            >
                                                <i className="fa fa-lock nav-icon" />
                                                <p>Roles</p>
                                            </NavLink>
                                        </li>
                                    )}
                                </ul>
                            </li>
                        )}

                        {/* More */}
                        <li
                            className={`nav-item ${
                                openMenus.more ? "menu-open" : ""
                            }`}
                        >
                            <div
                                onClick={() => toggleMenu("more")}
                                className={`nav-link`}
                            >
                                <i className="nav-icon fa fa-angle-double-right tw-text-[#c2c7d0]" />
                                <p>
                                    <b className="tw-text-[#c2c7d0]">MORE...</b>
                                    <i className="fas fa-angle-left right tw-text-[#c2c7d0]" />
                                </p>
                            </div>
                            <ul
                                className="nav nav-treeview"
                                style={{
                                    display: openMenus.more ? "block" : "none",
                                }}
                            >
                                {showSettings && (
                                    <li className="nav-item">
                                        <NavLink
                                            className="nav-link"
                                            to="/settings"
                                        >
                                            <i className="fa fa-wrench nav-icon" />
                                            <p>Settings</p>
                                        </NavLink>
                                    </li>
                                )}
                                <li className="nav-item">
                                    <NavLink
                                        className="nav-link"
                                        to="/webhooks"
                                    >
                                        <i className="fa fa-link nav-icon" />
                                        <p>Webhooks</p>
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink
                                        className="nav-link"
                                        to="/integrations"
                                    >
                                        <i className="fa fa-plug nav-icon" />
                                        <p>Integrations</p>
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink
                                        className="nav-link"
                                        to="/notifications"
                                    >
                                        <i className="fa fa-bullhorn nav-icon" />
                                        <p>Notifications</p>
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            </div>
        </aside>
    );
}

export default Menu;
